/**
 *  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
 *
 * THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
 * AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
 * WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
 * TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
 * AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
 * INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
 * PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
 * CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
 * OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
 * ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
 * THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CommonConstants } from './constants/common-constants';

interface LoggerResponse {
  success: boolean;
}

@Injectable()
export class ZsdLoggingService {
  // Objects for errors of different types
  logError = {};
  debugError = {};
  warnError = {};
  infoError = {};

  constructor(public http: HttpClient) {}

  // log errors
  log(value: string, component: string, ...rest: any[]) {
    this.logError = {
      error: value,
      component: component,
      additional: [...rest],
      timestamp: new Date().toISOString(),
      'error-level': 'log'
    };
    this.sendErr(this.logError);
  }

  // debug errors
  debug(value: string, component: string, ...rest: any[]) {
    this.debugError = {
      error: value,
      component: component,
      additional: [...rest],
      timestamp: new Date().toISOString(),
      'error-level': 'debug'
    };
    this.sendErr(this.debugError);
  }

  // client side errors
  handleError(error) {
    let date = new Date().toISOString();
    if (error.error instanceof Error) {
      console.error('An client side error occured', error.message);
    } else {
      console.error(date, 'There was a Type error.', error.message);
    }
  }

  // warning errors
  warn(value: string, component: string, ...rest: any[]) {
    this.warnError = {
      error: value,
      component: component,
      additional: [...rest],
      timestamp: new Date().toISOString(),
      'error-level': 'warn'
    };
    this.sendErr(this.warnError);
  }

  // info errors
  info(value: string, component: string, ...rest: any[]) {
    this.infoError = {
      error: value,
      component: component,
      additional: [...rest],
      timestamp: new Date().toISOString(),
      'error-level': 'info'
    };
    this.sendErr(this.infoError);
  }

  // sending errors to server
  sendErr(errors: any) {
    this.http
      .post<LoggerResponse>(
        CommonConstants.SERVICE_VERSION_PATH_V1 + '/logger/logs',
        errors
      )
      .subscribe(
        (response: any) => {
          if (response.success === true) {
          }
        },
        error => {
          // saving errors in local-storage
          console.error(error);
          localStorage.setItem('error-logs', JSON.stringify(errors));
          let errorLogs = localStorage.getItem('error-logs');
          // sending errors to server when server is down after 5 seconds
          setTimeout(() => {
            this.http
              .post<LoggerResponse>(
                CommonConstants.SERVICE_VERSION_PATH_V1 + '/logger/logs',
                errorLogs
              )
              .subscribe(response => {
                if (response.success === true) {
                }
              });
            localStorage.removeItem('error-logs');
          }, 5000);
        }
      );
  }
}
